// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

/**
 * Function to build ArcGIS corresponding simple renderer configurations based on a config object and geometry type.
 * @param configObj The configuration object containing symbol information.
 * @param geometryType The geometry type ('point', 'multipoint', 'polyline', 'polygon').
 * @param setColor Optional callback to track the color for UI elements.
 * @returns An ArcGIS simple renderer configuration object.
 */
const getRendererForConfig = (
  configObj: any,
  geometryType: string,
  setColor?: (color: string) => void,
) => {
  const sym = configObj.symbol;

  if (sym?.color && setColor) {
    setColor(sym.color);
  }

  let newRenderer: any;

  if (geometryType === 'point' || geometryType === 'multipoint') {
    newRenderer = {
      type: 'simple',
      symbol: {
        type: 'simple-marker',
        style: 'circle',
        color: sym.color,
        size: sym.size || 8,
        outline: {
          color: sym.outlineColor || '#000000',
          width: sym.outlineWidth || 1,
        },
      },
    };
  } else if (geometryType === 'polyline') {
    newRenderer = {
      type: 'simple',
      symbol: {
        type: 'simple-line',
        color: sym.color,
        width: sym.width || 2,
      },
    };
  } else if (geometryType === 'polygon') {
    newRenderer = {
      type: 'simple',
      symbol: {
        type: 'simple-fill',
        style: sym.fillStyle || 'none',
        color: sym.color,
        outline: {
          color: sym.outlineColor || '#000000',
          width: sym.outlineWidth || 1,
        },
      },
    };
  }

  return newRenderer;
};
export default getRendererForConfig;
